import { render, staticRenderFns } from "./AwardsImageUpload.vue?vue&type=template&id=132aad36&scoped=true"
import script from "./AwardsImageUpload.vue?vue&type=script&lang=js"
export * from "./AwardsImageUpload.vue?vue&type=script&lang=js"
import style0 from "./AwardsImageUpload.vue?vue&type=style&index=0&id=132aad36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132aad36",
  null
  
)

/* custom blocks */
import block0 from "./AwardsImageUpload.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports